const jobStatusKeys = {
  'Pendente': 'status_pending',
  'Em andamento': 'status_in_progress',
  'Finalizado': 'status_finished',
  'Não iniciado': 'status_not_started',
  'Nao iniciado': 'status_not_started',
  'Erro na execução': 'status_execution_error'
};

const moduleKeys = {
  student_portal: 'settings_student_portal'
};

const featureKeys = {
  edital: 'settings_notice',
  essay: 'essays',
  exam: 'settings_results',
  resource: 'settings_appeals'
};

const subFeatureKeys = {
  'resource-question': 'settings_question_appeals'
};

export const translateJobStatus = (t, status) =>
  jobStatusKeys[status] ? t(jobStatusKeys[status]) : status;

export const translateModuleLabel = (t, module) =>
  moduleKeys[module.moduleKey] ? t(moduleKeys[module.moduleKey]) : module.label;

export const translateModuleDescription = (t, module) =>
  module.moduleKey === 'student_portal'
    ? t('settings_student_portal_description')
    : module.description;

export const translateFeatureLabel = (t, feature) =>
  featureKeys[feature.feature_key] ? t(featureKeys[feature.feature_key]) : feature.label;

export const translateSubFeatureLabel = (t, subFeature) =>
  subFeatureKeys[subFeature.subFeatureKey]
    ? t(subFeatureKeys[subFeature.subFeatureKey])
    : subFeature.label;
